import * as React from 'react';
import VectorLickd from "./vector-lickd";
import {classes, style} from 'typestyle';
import {centerJustified, horizontal, vertical} from 'csstips';
import {percent, rem} from 'csx';
import {gradientBackground} from '../theme/gradient';
import {mixinPositionAbsoluteFill} from '../theme/mixin';

interface Props {
  className?: string;
  styles?: typeof VectorBackground.styles;
}

interface State {
  scale: number;
  loaded: boolean;
  stretchY: boolean;
}

export default class VectorBackground extends React.Component<Props, State> {
  public $el?: any;

  public state = {
    scale: 1,
    loaded: false,
    stretchY: true,
  };

  public render() {
    const { scale, loaded, stretchY } = this.state;
    const { styles = VectorBackground.styles, className } = this.props;
    const transform = `rotate(-30deg) scale(${scale})`;
    const opacity = loaded ? 1 : 0;

    return (
      <div ref={el => this.$el = el} className={classes(className, styles.vectorBackground)}>
        <div className={styles.background}>
          <div className={classes(styles.frame, stretchY && styles.frameStretchY)} style={{transform, opacity}}>
            <span className={styles.container} />
            <div>
              <VectorLickd/>
              <VectorLickd/>
              <VectorLickd/>
              <VectorLickd/>
            </div>
            <div>
              <VectorLickd/>
              <VectorLickd/>
              <VectorLickd/>
              <VectorLickd/>
            </div>
            <div>
              <VectorLickd/>
              <VectorLickd/>
              <VectorLickd/>
              <VectorLickd/>
            </div>
            <div>
              <VectorLickd/>
              <VectorLickd/>
              <VectorLickd/>
              <VectorLickd/>
            </div>
            <div>
              <VectorLickd/>
              <VectorLickd/>
              <VectorLickd/>
              <VectorLickd/>
            </div>
            <div>
              <VectorLickd/>
              <VectorLickd/>
              <VectorLickd/>
              <VectorLickd/>
            </div>
            <div>
              <VectorLickd/>
              <VectorLickd/>
              <VectorLickd/>
              <VectorLickd/>
            </div>
          </div>
        </div>
        {this.props.children}
      </div>
    );
  }

  public componentDidMount() {
    this.updateScale();
    window.addEventListener('resize', this.updateScale);
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.updateScale);
  }

  protected updateScale = () => {
    if (!this.$el) {
      return;
    }

    const {height, width} = this.$el.getBoundingClientRect();

    const scaleX = width / VectorBackground.viewport.width;
    const scaleY = height / VectorBackground.viewport.height;
    const scale = Math.max(scaleX, scaleY);
    const stretchY = height > width;

    this.setState({scale, stretchY, loaded: true});
  };

  static viewport = {
    width: 1920,
    height: 1080
  };

  static styles = {
    vectorBackground: style({
      overflow: 'hidden',
      position: 'relative',
      zIndex: 0,
    }),
    background: style({
      ...vertical,
      ...centerJustified,
      ...mixinPositionAbsoluteFill,
      zIndex: -1,
    }),
    frame: style({
      zIndex: 0,
      position: 'relative',
      height: rem(67.5),
      width: rem(120),
      transformOrigin: 'center center',
      transition: 'opacity 0.25s ease-in',
      $nest: {
        '& > div': {
          ...horizontal,
          height: rem(13.5),
          width: percent(100),
        },
        '& > div + div': {
          marginTop: rem(3)
        },
        '& > div:nth-child(2n)': {
          marginLeft: rem(16)
        },
        '& svg': {
          flex: 1,
        },
        '& svg + svg': {
          marginLeft: rem(3)
        }
      }
    }),
    frameStretchY: style({
      marginLeft: percent(-50),
    }),
    container: style({
      ...mixinPositionAbsoluteFill,
      zIndex: -1,
      transform: `rotate(30deg)`,
      background: gradientBackground,
    }),
  }
}
